export const currencyTypes = ['USD', 'EUR', 'INR', 'YEN']
